<template>
  <section class="hero">
    <div class="hero-text">
      <h1>Yvonne och Oscars bröllop</h1>
    </div>
  </section>
</template>

<script>
export default {
  name: "WeddingHero"
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap');

.hero {
  position: relative;
  width: 100%;
  height: 50vh; /* Reduced vertical extent */
  background: url('~@/assets/botanical-background-with-branches-top.jpg') no-repeat center center;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  filter: grayscale(0.5) brightness(1.9);
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.hero-text {
  position: relative;
  text-align: center;
  color: black;
  animation: fadeInUp 2s ease-out;
}
.hero-text h1 {
  font-family: 'Cochocib Script', Serif;
  font-size: 10rem;
  letter-spacing: 2px;
  margin: 0;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 600px) {
  .hero-text h1 {
    font-size: 2.5rem;
  }
}
</style>
